export const onScroll = (tableAPI) => {
  const scroll = window.innerHeight + window.scrollY;
  if (tableAPI.loaded && scroll >= document.body.scrollHeight * 0.85) {
    return tableAPI.fetchMore();
  }
}
